module.exports = __webpack_public_path__ + "img/place.9e0243e2.webp";